var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 34 34",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 33.9979V20.8458C34 13.7993 30.405 10.5204 25.6096 10.5204C21.7401 10.5204 20.0071 12.7471 19.0423 14.3094V11.0583H11.7539C11.8502 13.2121 11.7539 33.9979 11.7539 33.9979H19.0423V21.1865C19.0423 20.5029 19.0894 19.8171 19.282 19.3285C19.8084 17.959 21.0068 16.5403 23.0204 16.5403C25.6588 16.5403 26.7137 18.6427 26.7137 21.7266V34L34 33.9979ZM4.07435 7.92726C6.61441 7.92726 8.19786 6.1635 8.19786 3.96256C8.15074 1.71232 6.61441 0 4.12146 0C1.62851 0 0 1.71232 0 3.96256C0 6.16565 1.5814 7.92726 4.02928 7.92726H4.07435ZM7.71852 33.9979V11.0583H0.432221V33.9979H7.71852Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.d7982c6281b82416abaa8d426fdd41d7.svg";
export { ForwardRef as ReactComponent };